import { withInstall } from '../_util'

import Querytable from './Querytable'
import QuerytableColumnIndex from './columns/QuerytableColumnIndex'
import QuerytableColumnString from './columns/QuerytableColumnString'
import QuerytableColumnLink from './columns/QuerytableColumnLink'
import QuerytableColumnNumber from './columns/QuerytableColumnNumber'
import QuerytableColumnDate from './columns/QuerytableColumnDate'
import QuerytableColumnSingleselect from './columns/QuerytableColumnSingleselect'
import QuerytableColumnMultiselect from './columns/QuerytableColumnMultiselect'
import QuerytableColumnButtongroup from './columns/QuerytableColumnButtongroup'
import QuerytableCellButton from './columns/QuerytableCellButton'
import QuerytableColumngroup from './columns/QuerytableColumngroup'
import QuerytableColumnDiy from './columns/QuerytableColumnDiy'

export type { QuerytableProps } from './Querytable'

export default withInstall<
  typeof Querytable,
  {
    QuerytableColumnIndex: typeof QuerytableColumnIndex
    QuerytableColumnString: typeof QuerytableColumnString
    QuerytableColumnLink: typeof QuerytableColumnLink
    QuerytableColumnNumber: typeof QuerytableColumnNumber
    QuerytableColumnDate: typeof QuerytableColumnDate
    QuerytableColumnSingleselect: typeof QuerytableColumnSingleselect
    QuerytableColumnMultiselect: typeof QuerytableColumnMultiselect
    QuerytableColumnButtongroup: typeof QuerytableColumnButtongroup
    QuerytableCellButton: typeof QuerytableCellButton
    QuerytableColumngroup: typeof QuerytableColumngroup
    QuerytableColumnDiy: typeof QuerytableColumnDiy
  }
>(Querytable, {
  QuerytableColumnIndex,
  QuerytableColumnString,
  QuerytableColumnLink,
  QuerytableColumnNumber,
  QuerytableColumnDate,
  QuerytableColumnSingleselect,
  QuerytableColumnMultiselect,
  QuerytableColumnButtongroup,
  QuerytableCellButton,
  QuerytableColumngroup,
  QuerytableColumnDiy,
})
